
function TestClosest(){


    let content = document.getElementById("root");
    let body = content?.closest("body");



    if(body)
        return true;
    else
        return false;

}

const ClosestData = {

    hasTested:false,
    useClosest:false,
}


export function ClosestWithClass(dom:null|Element, className:string):Element|null|undefined {

    if(!ClosestData.hasTested){
        ClosestData.useClosest = TestClosest();
        ClosestData.hasTested = true;

    }else if(ClosestData.useClosest){
        return dom?.closest("."+className);
    }

    while (dom) {
        if (dom.classList.contains(className)) {
            return dom;
        }
        dom = dom.parentElement;
    }
    return null;
}

export function ClosestWithID(dom:null|Element, id:string):Element|null|undefined {
    if(!ClosestData.hasTested){
        ClosestData.useClosest = TestClosest();
        ClosestData.hasTested = true;

    }
    else if(ClosestData.useClosest){
        return dom?.closest("#"+id);
    }

    while (dom) {
        if (dom.id==id) {
            return dom;
        }
        dom = dom.parentElement;
    }
    return null;
}

export function ClosestWithTag(dom:null|Element, tag:string):Element|null|undefined {
    if(!ClosestData.hasTested){
        ClosestData.useClosest = TestClosest();
        ClosestData.hasTested = true;

    }
    else if(ClosestData.useClosest){
        return dom?.closest(tag);
    }


    tag = tag.toLocaleLowerCase();
    while (dom) {
        if (dom.tagName.toLowerCase()==tag) {
            return dom;
        }
        dom = dom.parentElement;
    }
    return null;
}